module.exports=function(scope){ return `{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev"
    },
    "data": {
        "sessionToken": "..."
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/success/session-token.json.tpl